export const animations = [
  {
    label: "Bounce",
    classes: [
      "a-dance",
      "a-journal",
      "a-pulse",
      "a-pulse-slow",
      "a-jamp",
      "a-four-rock",
    ],
  },
  {
    label: "Fading Entrances",
    classes: ["a-flip-top", "a-flip-left", "a-flip-right", "a-flip-bottom"],
  },
  {
    label: "Jello",
    classes: ["a-jello-vertical", "a-jello-horizontal"],
  },
  {
    label: "Rotate",
    classes: ["a-rotate-flip-down", "a-rotate-down-bounce", "a-rotate-out"],
  },
  {
    label: "Agrecives",
    classes: ["a-flash-bang", "a-bomb"],
  },
  {
    label: "Perspective",
    classes: [
      "a-flip-left-bounce",
      "a-rotate-flip",
      "a-flip-right-bounce",
      "a-three-flip-right",
      "a-three-flip-left",
      "a-three-flip-up",
      "a-three-flip-down",
    ],
  },
  {
    label: "Wobble",
    classes: [
      "a-wobble-bottom",
      "a-wobble-top",
      "a-wobble-left",
      "a-wobble-right",
    ],
  },
  {
    label: "Vibrate",
    classes: ["a-vibrate-low", "a-vibrate-medium", "a-vibrate-high"],
  },
];
